import React, { FC, useMemo } from 'react'
import { OrgSegmentModel } from '../../../models/segments/org-segment.model'
import { NoTranslate } from '../../no-translate/no-translate'
import { TableRowEntityDisplay } from '../../table-row-entity-display/table-row-entity-display'
import { SegmentModel } from '../../../models/segments/segment.model'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../../services'

type SegmentRowSegmentDisplayProps = {
    level: 'org' | 'domain'
    segment: OrgSegmentModel | SegmentModel
    canMutate: boolean
    canEditOrgSegment: boolean
}

export const SegmentRowDisplay: FC<SegmentRowSegmentDisplayProps> = ({
    level,
    segment,
    canMutate,
    canEditOrgSegment,
}) => {
    const appSvc = useService(AppService)

    const segmentName = segment?.getName()
    const canEdit = level === 'org' ? canEditOrgSegment : canMutate

    const renderedTitle = useMemo(
        () =>
            !canEdit ? (
                <NoTranslate>{segmentName}</NoTranslate>
            ) : (
                <a href={appSvc.routeWithin(level, `/segments/${segment?.getId()}`, true)} target="_blank">
                    <NoTranslate>{segmentName}</NoTranslate>
                </a>
            ),
        [canEdit, segmentName],
    )

    return <TableRowEntityDisplay title={renderedTitle} />
}
